import React from "react";
import { Link } from "react-router-dom";
import "./PolicyPages.css";

const PrivacyPolicy = () => {
  return (
    <div className="policy-page">
      {/* Hero Banner */}
      <section className="policy-banner">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6">
              <h1>Privacy Policy</h1>
            </div>
            <div className="col-md-6 d-flex justify-content-end">
              <figure className="policy-image">
                <img
                  src="/assets/images/data-protection.svg"
                  alt="Privacy Policy"
                />
              </figure>
            </div>
          </div>
        </div>
      </section>

      {/* Content Section */}
      <section className="policy-content">
        <div className="container">
          <div className="policy-content-inner">
            <p>
              <strong>Data created:</strong> October 2019
            </p>
            <p>
              <strong>Data updated:</strong> January 10, 2025
            </p>

            <p>
              This Privacy Policy is posted by Divergent Insights Pte Ltd
              (hereinafter called as "Divergent Insights") encourages our
              customers, visitors, business associates, and other interested
              parties to read this Privacy Notice, which applies to all users.
              By using our Service or submitting personal/business information
              to Divergent Insights by any other means, you acknowledge that you
              understand and agree to be bound by this Privacy Notice, and agree
              that Divergent Insights may collect, process, transfer, use, and
              disclose your personal/business information as described in this
              Notice. Further, by accessing any part of the Service, you are
              agreeing to the terms and conditions of our terms of service (the
              "terms of service"). if you do not agree with any part of this
              privacy notice or our terms of service, please do not use any of
              the services.
            </p>

            <p>
              We've developed this Policy to describe (1) how we collect, use,
              transfer, and store information of individuals; (2) your choices
              regarding your personal information; and (3) how we ensure your
              privacy.
            </p>

            <p>
              We, Divergent Insights Pte. Ltd ("Company") on behalf of itself
              and its affiliates worldwide under "Divergent Insights", having
              its principal office at 10 Anson Road, #22-02 International Plaza,
              Singapore 079903 as data controller.
            </p>

            <p>
              Divergent Insights Pte Ltd (referred to as "our", "us" and "we" in
              this notice) is part of Divergent Insights Group, a global market
              research group. We help our clients to improve how they advertise
              and market, whether by print, post, email or on websites. We
              believe that the responsible use of data supports business growth
              and builds strong relationships between brand and consumer. As a
              business, we are committed to respecting and protecting the
              privacy of all individuals with whom we interact. We are committed
              to being always transparent in our handling of personal
              information and processing personal information in accordance with
              applicable privacy and data protection laws.
            </p>

            <p>
              As part of its social responsibility, Divergent Insights is
              committed to international compliance with data protection laws,
              regulations, and rules. This privacy & data protection policy ("
              <strong>Policy</strong>" or "
              <strong>Data Protection Policy</strong>") applies worldwide to
              Divergent Insights and is based on globally accepted basic
              principles on data protection. This Policy adopts the fundamental
              principles of the EU's{" "}
              <strong>General Data Protection Regulation</strong> ("
              <strong>GDPR</strong>") as the minimum standard to which Divergent
              Insights, its employees and suppliers must adhere. Although this
              should go without saying, it does not make GDPR itself applicable
              to us globally.
            </p>

            <p>
              Divergent Insights depends on the collection and analysis of
              information about identifiable living individuals ("
              <strong>Data Subjects</strong>") to carry out its market research
              and associated business. Maintaining respondents' and the public's
              confidence requires that respondents do not suffer direct risk, or
              harm because of providing us with their information or their
              Personal Data being processed for our business purposes.
            </p>

            <p>
              To conduct its business, Divergent Insights needs to collect and
              process certain types of information, including Personal Data,
              about people with whom Divergent Insights deals. In addition,
              Divergent Insights may occasionally be required by law to process
              certain types of Personal Data to comply with certain legal
              requirements.
            </p>

            <p>
              The Policy is applicable globally to Divergent Insights,
              regardless of where they are based. Within Divergent Insights,
              this Policy will form the minimum standard to which all employees
              and suppliers must adhere, regardless of whether GDPR directly
              applies to any specific activity or territory.
            </p>

            <p>
              Everyone who works for Divergent Insights has some responsibility
              for ensuring Personal Data is collected, stored, and handled
              appropriately. It is everyone's responsibility that Personal Data
              is handled and processed in line with this Policy and its data
              protection principles. Divergent Insights also expects that its
              suppliers/vendors comply with the principles as set out herein.
            </p>

            <p>
              This Privacy Notice explains what personal information we collect
              from you, how we use it and what your rights are. This privacy
              notice does not apply to Divergent Insights' processing of
              employee personal data.
            </p>

            <p>
              <strong>This Privacy Notice explains the following:</strong>
            </p>
            <ul className="policy-list">
              <li>What personal information we collect;</li>
              <li>How we use this information;</li>
              <li>How long we keep your personal information;</li>
              <li>How we secure your personal information;</li>
              <li>Information Sharing and Disclosure;</li>
              <li>
                International and group company transfers of personal
                information;
              </li>
              <li>
                Your rights regarding the personal information you provide to
                us;
              </li>
              <li>Our responsibility for website links;</li>
              <li>Updates;</li>
              <li>How to contact us.</li>
            </ul>

            <h3>What personal information we collect</h3>
            <p>
              We may collect personal information in a number of different
              contexts.
            </p>

            <h4>
              What personal information we collect during the course of our
              market research studies
            </h4>
            <p>
              The Company conducts market research surveys on behalf of our
              clients / survey sponsors. These studies collect data for research
              purposes only and the information gathered is not used for
              marketing or sales. Unless you are specifically informed otherwise
              (for example by specifically consenting for your personal
              information to be shared with our client), the details you provide
              are used for aggregated analysis – that is, responses are pooled
              with those of other survey participants and are reported to our
              clients / survey sponsors anonymously.
            </p>

            <p>
              We may collect information such as name, job title, company name,
              e-mail address and job title from certain public and non-public
              sources, such as our corporate website and third-party business
              contact data suppliers. We may also receive the information such
              as name, job title, company name, e-mail address and job title
              from our clients, who are usually suppliers of services looking
              for feedback on their products, services or industry from their
              customers.
            </p>

            <p>
              In online surveys, we may collect your IP address. This is only
              used for quality checking purposes and to prevent fraud. We never
              use an IP address to identify individuals.
            </p>

            <h4>What personal information we collect on our website</h4>
            <p>
              We collect information such as name, job title, company name,
              postal address, e-mail address and telephone number. This
              information may be shared through forms, e-mail or via telephone.
              Where personal information is collected through our website or our
              online services in this way, this will be clearly indicated.
            </p>

            <p>
              We collect information about how you use our website and the
              device(s) you use to access our site. This includes collecting
              unique mobile device ID or the internet protocol (IP) address
              online identifiers, which are numbers that can uniquely identify a
              specific computer or other network device on the internet. This
              information is linked to a cookie ID, which we receive and
              process.
            </p>

            <p>
              We also collect information about you if you make use of any of
              the interactive features within our website that rely on a
              personalised response, or where you ask us to respond to a query
              you have or add your details to one of our alert or subscription
              services. The information we collect is limited to the details we
              need to provide the specific service you have asked for. We do not
              collect sensitive information, such as your political or religious
              beliefs, ethnic background, sexual preference, health or any other
              sensitive information unless it is necessary for the research
              purpose and you have given your explicit consent.
            </p>

            <p>
              We do not actively seek to collect information about children aged
              16 or under. If you have any concerns about your child’s privacy
              in relation to our services, or if you believe that your child may
              have entered personal information onto our website, please contact
              us at dpo@divergentinsights.com. We will delete such information
              from our records within a reasonable time.
            </p>

            <h4>Storage Limitation</h4>
            <p>
              Personal Data must not be retained in a form which permits
              identification of Data Subjects for longer than is necessary for
              the purpose for which the Personal Data are processed. Divergent
              Insights will not keep Personal Data longer than is necessary for
              the purpose or purposes for which they were collected Divergent
              Insights will take all reasonable steps to destroy, or erase from
              its systems, all Personal Data which are no longer required. This
              does not apply to anonymised data.
            </p>

            <h4>General Measures and Considerations</h4>
            <p>
              Additionally, in respect of its market research business Divergent
              Insights complies with the ESOMAR International Code on Market,
              Opinion, and Social Research and Data Analytics and ESOMAR’s Data
              Protection Checklist.
            </p>

            <h3>How we use this information</h3>
            <p>
              Except where required by law, we use the personal data you provide
              for the following purposes:
            </p>
            <ul className="policy-list">
              <li>To provide market research services to our clients;</li>
              <li>
                to deliver the specific information or services you have
                requested;
              </li>
              <li>to enable the download of our content;</li>
              <li>
                send you newsletters and information relating to our brands and
                services;
              </li>
              <li>respond to your requests and feedback; and</li>
              <li>analyse and/or improve our services.</li>
            </ul>
            <p>
              Under data protection law we are required to advise you on the
              legal basis for processing your personal data. For the most part,
              the processing of your personal information is based either on a)
              our legitimate interests related to us providing you services you
              have requested or otherwise your customer relationship with us, or
              b) your consent, where requested. In the table below we set out
              further information about the purposes for which we use your
              personal data and the legal basis we rely on for its use. Note
              that we may process your personal data for more than one lawful
              basis depending on the specific purpose for which we are using
              your data.
            </p>

            <table className="policy-table">
              <thead>
                <tr>
                  <th>Purpose/Activity</th>
                  <th>Types of personal data that may be processed</th>
                  <th>
                    Lawful basis for processing including basis of legitimate
                    interest
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    Collection of personal information from public sources
                  </td>
                  <td>
                    (a) Name (b) Email address (c) Company (d) Telephone number
                    (e) job title
                  </td>
                  <td>
                    Necessary for our legitimate interests of sourcing potential
                    participants to a market research study, in a
                    business-to-business context and largely using corporate
                    office switchboard numbers.
                  </td>
                </tr>
                <tr>
                  <td>To contact you to conduct a market research study</td>
                  <td>
                    (a) Name (b) Email address (c) Company (d) Telephone number
                    (e) job title
                  </td>
                  <td>
                    To the extent that we collect information that has not been
                    passed to us by our clients (in which case our client will
                    provide an approach lawful basis for contacting you, with
                    our client acting as data controller), we rely on your
                    consent to contact you to continue a market research study.
                  </td>
                </tr>
                <tr>
                  <td>
                    To conduct the market research study including recording
                    responses and developing a report for our client/survey
                    sponsor; verifying or validating answers you provide,
                    including for internal quality control purposes; and to
                    obtain extended (open-ended) information that helps to
                    provide context for your survey responses – for example, the
                    nature of a complaint that has arisen while using our
                    clients’ products or services
                  </td>
                  <td>
                    (a) Name (b) Email address (c) Company (d) Telephone number
                    (e) job title (f) IP address (for online surveys) (g) other
                    personal information which may be shared during the course
                    of a market research interview
                  </td>
                  <td>
                    We rely on your consent to process personal information
                    relating to your continued participation in a market
                    research study. To the extent that we make audio or visual
                    recordings of a market research study, our lawful basis is
                    our legitimate interest in creating a record of the
                    discussion to support our creation of an accurate report for
                    our client/survey sponsor. You will always be notified
                    before any recording takes place. You should not participate
                    in a study which involves recording, if you are not happy to
                    be recorded.
                  </td>
                </tr>
                <tr>
                  <td>
                    To share your personal information with our client or survey
                    sponsor
                  </td>
                  <td>
                    (a) Name (b) Audio or visual recording (c) Attributed
                    quotations (d) Job title
                  </td>
                  <td>
                    In some cases, we may ask for your consent to share your
                    personal data and responses with a third party in digital
                    (data file), audio or some other format. You are under no
                    obligation to agree to this and you will always be informed
                    who these third parties are (usually the survey sponsor). We
                    would share this personal information on the basis of your
                    consent.
                  </td>
                </tr>
                <tr>
                  <td>To manage incentives</td>
                  <td>(a) Name (b) E-mail address (c) Job title</td>
                  <td>
                    Some projects may include an incentive for taking part.
                    These incentives will be processed by our staff. Incentives
                    will usually be in the form of a gift voucher or charitable
                    donation. Incentives will only be awarded if a survey or
                    research activity is fully completed. We process this
                    personal information on the basis of your consent.
                  </td>
                </tr>
                <tr>
                  <td>
                    To send you information about our services: · To send you
                    information which you have requested e.g. newsletters or
                    publications in accordance with your specified preferences
                  </td>
                  <td>(a) Name (b) Email address (c) Company (d) Location</td>
                  <td>
                    Where you have requested information from us, such as
                    newsletters, publications or event invitations, we send such
                    communications based on your consent. You can ask us to stop
                    such communications at any time by clicking on the
                    unsubscribe link at the bottom of the message.
                  </td>
                </tr>
                <tr>
                  <td>
                    To improve and develop our website: · We conduct statistical
                    analysis on your usage of the website e.g. to enable us to
                    improve our website, offer new features and material etc.
                  </td>
                  <td>(a) Technical (b) Usage</td>
                  <td>
                    Necessary for our legitimate interest (to define types of
                    clients for our services, to keep our website updated and
                    relevant, to develop our business and to inform our
                    marketing strategy).
                  </td>
                </tr>
                <tr>
                  <td>
                    To deliver relevant content to you and measure or understand
                    the effectiveness of the content we serve to you.
                  </td>
                  <td>
                    (a) Name (b) Email address (c) Company (d) Location (e)
                    Usage (f) Marketing and communications (g) Technical
                  </td>
                  <td>
                    Necessary for our legitimate interests (to study how clients
                    use our service and engage with our content. To develop our
                    service, to grow our business and to inform our marketing
                    strategy).
                  </td>
                </tr>
                <tr>
                  <td>
                    To respond to any enquiries or feedback that you send us· To
                    update you with any changes to our terms and
                    conditions/other policies
                  </td>
                  <td>(a) Name (b) Email address (c) Company (d) Location</td>
                  <td>
                    It is in our legitimate interest to respond to
                    communications that you send to us, inform you of relevant
                    information in relation to the services that we provide and
                    utilise your information to improve our business.
                  </td>
                </tr>
                <tr>
                  <td>
                    To reach out with information on our products and services
                    relevant to your needs
                  </td>
                  <td>(a) Name (b) Email address (c) Location (d) Usage</td>
                  <td>
                    It is our legitimate interests to work out which of our
                    products or services may interest you and tell you about
                    them. Our offices outside of the UK may reach out to you
                    with such information based on your consent.
                  </td>
                </tr>
                <tr>
                  <td>To share information with our service providers.</td>
                  <td>
                    (a) Name (b) Email address (c) Usage (d) Marketing and
                    communications (e) Technical
                  </td>
                  <td>
                    It is our legitimate business interest to share your data
                    with trusted third parties who provide us with services
                    relevant to the provision of our website.
                  </td>
                </tr>
                <tr>
                  <td>
                    To share information within the Divergent Insights group.
                  </td>
                  <td>(a) Name (b) Email address (c) Location (d) Usage</td>
                  <td>
                    As Divergent Insights operates as a global operating market
                    research company, it is our legitimate business interest to
                    share your data within the group in order to manage our
                    business effectively and provide our products and services.
                  </td>
                </tr>
                <tr>
                  <td>
                    To share information with other third parties, such as
                    regulator and law enforcement agencies
                  </td>
                  <td>
                    (a) Name (b) Email address(c) Location (d) Usage (e)
                    Technical
                  </td>
                  <td>
                    We share your data as necessary for compliance with any
                    legal obligation to which we are subject or in order to
                    satisfy our legitimate business interests.
                  </td>
                </tr>
              </tbody>
            </table>

            <h3>How long we keep your personal information</h3>
            <p>
              We store your personal information in accordance with legal,
              regulatory, financial and best-practice business requirements.
              Once your personal information is no longer necessary, we will
              securely delete/destroy your data in line with our data retention
              policies. Our standard retention period for personal data relating
              to market research studies is 3 years.
            </p>

            <h3>How we secure your personal information</h3>
            <p>
              We maintain appropriate organisational and technological
              safeguards to help protect against unauthorised use, access to or
              accidental loss, alteration or destruction of personal data. We
              also seek to ensure our service providers do the same.
            </p>

            <h3>Information Sharing and Disclosure</h3>
            <p>
              We may send personal data collected from research surveys to third
              party organizations, but only when:
            </p>

            <ul className="policy-list">
              <li>
                We have your express consent to share the information with a
                research sponsor for a specified and limited purpose (e.g. to
                resolve a customer service problem);
              </li>
              <li>
                We need to share this information to provide you with
                information you have specifically requested;
              </li>
              <li>
                We need to respond to court orders or the requests of law
                enforcement agencies;
              </li>
              <li>
                We retain a third party to provide us with services, subject to
                that third party being able to comply with relevant legal
                requirements and obligations regarding the use of personal data;
              </li>
            </ul>
            <p>
              In addition, we have offices and operations in a number of
              international locations and we share information between our group
              companies for business and administrative purposes. Your personal
              information may also be stored in one or more databases hosted by
              third parties. These third parties do not have use or access to
              your personal information for any purpose other than cloud storage
              or retrieval. Where required or permitted by law, personal
              information may be provided to others, such as regulators and law
              enforcement agencies, for example in response to a court order or
              a subpoena, or in response to a law enforcement agency’s request,
              or where we believe it is necessary to investigate, prevent or
              take action regarding illegal activities, and as otherwise
              required by law. From time to time, we may consider corporate
              transactions such as a merger, acquisition, reorganisation, asset
              sale, or similar. In these instances, we may transfer or allow
              access to information to enable the assessment and undertaking of
              that transaction. If we buy or sell any business or assets,
              personal information may be transferred to third parties involved
              in the transaction.
            </p>

            <h3>
              International and group company transfers of personal information
            </h3>
            <p>
              We are part of an international group of companies and, as such,
              from time to time we may transfer personal information concerning
              you to countries outside the European Union (“EU”).
            </p>

            <p>
              Where we transfer personal information outside of EU, we either
              transfer personal information to countries that provide an
              adequate level of protection (as determined by the European
              Commission) or we have appropriate safeguards in place.
            </p>

            <p>
              If you would like more information on the any of the data transfer
              mechanisms on which we rely please contact us at using the details
              provided below.
            </p>

            <h3>International Data Transfer</h3>

            <p>
              If you are in Switzerland, the United Kingdom, or the European
              Economic Area (“EEA”), please note that we and our servers are
              located outside of the EEA. Any information that you provide to us
              may be transferred to and processed in Indian and other countries
              around the world where we do business. Although this may include
              recipients of information located in countries where there may be
              a lower level of legal protection for your personal/business
              information than in your country, we will protect your information
              in accordance with requirements applicable to the law in your
              jurisdiction and take steps to only share with third parties that
              offer similar protection. By using our Service, you unambiguously
              consent to your information being collected, processed, used, and
              transferred as disclosed herein.
            </p>

            <h3>
              Your rights regarding the personal information you provide to us
            </h3>
            <p>General rights</p>
            <ul className="policy-list">
              <li>
                If you wish to stop receiving marketing communications from us
                then please click on the “unsubscribe” link at the bottom of the
                relevant mailing. If you wish to opt-out completely then please
                contact us at using the details provided below.
              </li>
              <li>
                If you would like us to delete your information from our
                records, please contact us using the contact details below and
                we will respond within a reasonable time. Please note that we
                may be required to retain certain information by law and/or for
                our own legitimate business purpose.
              </li>
              <li>
                the right to be informed about the processing of your Personal
                Data
              </li>
              <li>the right to have access to your Personal Data</li>
              <li>the right to update and/or correct your Personal Data</li>
              <li>the right to portability of your Personal Data</li>
              <li>
                the right to oppose or limit the processing of your Personal
                Data
              </li>
              <li>
                the right to request that we stop processing and delete your
                Personal Data
              </li>
              <li>
                the right to block any Personal Data processing in violation of
                any applicable law
              </li>
            </ul>

            <h4>
              Data Privacy Rights (European Union, South Africa and similar
              jurisdictions)
            </h4>
            <p>
              If you are from the European Union or similar jurisdictions, you
              have the right (with some exceptions and restrictions) to:
            </p>
            <ul className="policy-list">
              <li>
                Object to our processing of your personal information. You can
                object at any time and we will stop processing the information
                you have objected to, unless we can demonstrate compelling
                legitimate grounds for continuing that processing.
              </li>
              <li>
                Access your personal information. If you make this type of
                request and we have personal information about you, we are
                required to provide you with information about it, including a
                description and a copy of the personal information and why we
                are processing it.
              </li>
              <li>
                request erasure of your personal information in certain
                circumstances.
              </li>
              <li>
                request correction or updating of the personal information that
                we hold about you and that is inaccurate.
              </li>
              <li>
                Request restriction of our processing of your personal
                information in some situations. If you request it, we can
                continue storing your personal information, but we cannot
                process it while the restriction is in place.
              </li>
              <li>
                Withdraw your consent to our use of your personal information at
                any time. When you use our website, you may be asked for your
                consent to the use of cookies. You can withdraw your consent for
                us to process your personal information derived from cookies. If
                you withdraw consent, that will not affect the lawfulness of
                what we have done with your personal information before you
                withdrew consent.
              </li>
              <li>
                Object to our use of your personal information for direct
                marketing.
              </li>
              <li>
                Request portability of your personal information that we have,
                in certain circumstances.
              </li>
            </ul>

            <p>
              If you exercise the rights above and there is any question about
              who you are, we may require you to provide information from which
              we can satisfy ourselves as to your identity. If you are from the
              EU and would like to exercise any of these rights in relation to
              any information, we hold about you via this website please contact
              us using the contact details provided below. We will consider and
              respond to your request in accordance with the relevant law.
            </p>

            <h4>California Privacy Rights</h4>
            <p>
              As a California resident, the California Consumer Privacy Act
              ("CCPA") provides you with the opportunity to make inquiries about
              your personal/business information. Specifically, to the extent
              that information is not already provided in this Privacy Notice,
              you have the right to request disclosure about the collection and
              use of your personal/business information over the past 12 months,
              which includes:
            </p>
            <ul className="policy-list">
              <li>
                The categories of personal/business information collected about
                you.
              </li>
              <li>
                The categories of sources of the personal/business information
                collected about you.
              </li>
              <li>
                The business or commercial purpose for collecting your
                personal/business information.
              </li>
              <li>
                The categories of third parties with whom your personal/business
                information was shared.
              </li>
              <li>
                The specific pieces of personal/business information collected
                about you.
              </li>
              <li>
                If your personal/business information was disclosed for a
                business purpose, the categories of personal/business
                information disclosed and the categories of third parties to
                whom the information was disclosed.
              </li>
              <li>
                If your personal/business information was sold in the past 12
                months, the categories of personal/business information sold and
                the categories of third parties to whom the information was
                sold. (
                <strong>
                  NOTE: DIVERGENT INSIGHTS PTE DOES NOT SELL PERSONAL/BUSINESS
                  INFORMATION
                </strong>
                ).
              </li>
            </ul>

            <p>
              Please note that you may only make the above requests twice in a
              12-month period. You also have the right to request that any of
              your personal/business information collected and retained be
              deleted, subject to certain exceptions. If at any time you require
              us to cease processing your personal/business data, you may submit
              a request to delete your personal/business data by clicking on the
              “Unsubscribe” option OR by contacting us at{" "}
              <a href="mailto:dpo@divergentinsights.com">
                dpo@divergentinsights.com
              </a>
              .
            </p>

            <p>
              By following the appropriate instructions, your record will be
              marked as "no contact", and you will no longer receive
              communications from the Company. We will retain your information
              while your account is active or as needed to provide you services
              or in accordance with applicable laws. We will retain and use your
              information as necessary to comply with our legal obligations,
              resolve disputes, and enforce our agreements and other related
              purposes.
            </p>

            <h3>Our responsibility for website links</h3>
            <p>
              This Privacy Notice is limited to personal data collected by
              Divergent Insights Pte Ltd. We may provide links within our
              website to other websites, including social networking sites such
              as Facebook, Twitter and LinkedIn. If you follow these links, you
              should use these sites in conjunction with their respective
              privacy and user notices, as their data practices are outside the
              scope of this Privacy Notice. In addition, we cannot have
              responsibility or control over information collected by any
              third-party website and we cannot be responsible for the
              protection and privacy of any information which you may provide on
              such websites.
            </p>

            <h3>Data Protection Audit</h3>
            <p>
              Compliance with this Data Protection Policy and applicable data
              protection laws is checked periodically with data protection
              audits and other controls. The performance of these controls is
              the responsibility of the DPO, Internal Audit and/or external
              auditors engaged. Upon request, the results of data protection
              audits will be made available to the responsible data protection
              authorities.
            </p>

            <h3>Terms of use</h3>
            <p>
              This website utilizes Google Translate (via GTranslate) to offer
              language translations. While we strive to ensure accuracy, the
              translated content may not be completely accurate or reflect the
              original meaning. Please use it at your own discretion.
            </p>

            <h3>Updates</h3>
            <p>
              This Privacy Notice may be updated from time to time to reflect
              changes in the law, best practices or a change in our practices
              with respect to the treatment of personal data. The date of the
              most recent revision will appear at the top of this page. If you
              do not agree with the changes, please do not continue to use our
              services and refrain from sharing your personal data with us. You
              should consult this notice frequently to be aware of updates.
            </p>

            <div className="contact-info">
              <h3>How to contact us</h3>
              <p>
                If you have any questions about this Privacy Notice, our
                approach to privacy or you would like to exercise any of the
                rights mentioned in this Privacy Notice you can contact us on
                our email:
              </p>
              <p>
                <strong>Email:</strong>{" "}
                <a href="mailto:dpo@divergentinsights.com">
                  dpo@divergentinsights.com
                </a>
              </p>
            </div>

            <h3>SUPPLEMENTARY INFORMATION</h3>
            <p>
              In this Supplementary Information section, we explain some of the
              terminology used in this Privacy Notice.
            </p>

            <p>
              <strong>"data controller"</strong>: the person or company that
              controls the purposes and means of processing personal data.
            </p>

            <p>
              <strong>"personal data"</strong>: any information that relates to
              you (or from which you can be identified).
            </p>

            <p>
              <strong>"processing"</strong>: means doing anything with the data.
              For example, it includes collecting it, retaining it, disclosing
              it and deleting it.
            </p>

            <p>
              <strong>"transfer"</strong>: sending personal information outside
              the European Economic Area (e.g., by storing it on equipment
              located outside the European Economic Area), or allowing someone
              from outside the European Economic Area to access the personal
              information.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicy;
